function paramValueEqual(a, b) {
  if (Array.isArray(a) || Array.isArray(b)) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every(function(value, index) {
      return value === b[index];
    });
  }
  return a === b;
}
function mergeDynamicParams(params, dynamic, source) {
  if (!(dynamic === null || dynamic === void 0 ? void 0 : dynamic.length) || !source) return params;
  var next;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = dynamic[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var segment = _step.value;
      var value = source[segment.name];
      if (value == null || paramValueEqual(params === null || params === void 0 ? void 0 : params[segment.name], value)) continue;
      next !== null && next !== void 0 ? next : next = {
        ...params
      };
      next[segment.name] = value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return next !== null && next !== void 0 ? next : params;
}
export {
  mergeDynamicParams
};
//# sourceMappingURL=params.js.map
